import React,{useRef} from 'react'

import bg from '../../../images/guideline.jpg'

const PopupHowToUseDatabase = ({show}) => {

  const popupDefaultRef = useRef()

  return (
    <>
      {
        !show ? null : (
          <div className="popup-child" style={{display:`${show === 'How to use the database' ? '' : 'none'}`,opacity:`${show ? 1 : 0}`}}>
            <div className="popup-image-head" style={{background:`#000 url(${bg}) center center`,backgroundSize:'cover'}}>
              <div/>
              <section>
                <h6>Guidelines for database use</h6>
                <small>Header photo: © Unsplash</small>
              </section>
            </div>
            <div className="popup-child-text">
              <h4>How to use the WILDMEAT use data explorer</h4>
              <p>
                The <b>WILDMEAT Use Data Explorer</b> provides an easy way to interrogate the data held in the WILDMEAT Use database and download datasets. Anyone can use the map and search panels to search the database, either by species, by country, by individual references, or by using the customisable search tab on the left of the Explorer (Figure 1).
              </p>
              <p>
                To download individual datasets, please register as a Member, and this will give you access to the data download function (which you can see in the description section of each Study (see Figure 1 for an example). Datasets that you download will then become available in your WILDMEAT Member area. If you are a Data Provider, your Member area will also allow you to see the individual downloads of your datasets and contact the Data Users who have downloaded the data.
              </p>
              <p>
                Data is provided by Study. A Study is defined as including data of one data type – hunting, consumption, or offtake data – that has been collected using the same methodology throughout the survey, over a defined period, in one or more sites.
              </p>
              <p>To give some examples</p>
              <ul className="ul-popup">
                <li>If consumption data were collected using 48-hour recall, over 1 year, in 5 sites, this would be recorded as 1 study.</li>
                <li>If consumption data were collected in 2000 in one data collection effort, which was then repeated in 2010, using the same sites and methods, it would be recorded as two Studies.</li>
                <li>If consumption data were collected in the same sites, over the same period, using different methods (i.e., 48-hour recall and frequency from interviews) it would be recorded as two Studies.</li>
                <li>If consumption and offtake data were collected in the same sites, over the same period, it would be recorded as two Studies.</li>
              </ul>

              <p>
                A Study may contain data for several Sites, all with a specific Site ID, which is shown on the map. Site locations have been jittered by 40km to preserve the anonymity of Sites. If you require information on the location of the Site (such as habitat, population density, elevation etc.) for your analyses, please get in touch with the WILDMEAT team at <a href="mailto:info@wildmeat.org" target="_blank" rel="noreferrer">info@wildmeat.org</a>.
              </p>

              <p>
                [Image]<br/>
                <em>
                  Figure 1: a screenshot of the WILDMEAT data explorer, showing the Study information, and the download button, once the Data User has logged in.
                </em>
              </p>

              <h4>How to use the WILDMEAT Use data downloads</h4>
              <p>
                The WILDMEAT Use Database Users Guide provides a ‘how to’ guide for using the database, including detailed descriptions of the data structure, metadata descriptions, data limitations, and other useful information to ensure data from the database is employed correctly in your analyses.
              </p>
            </div>
          </div>
        )
      }
    </>
  )
}
export default PopupHowToUseDatabase
